"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncSyncGamblerSettings = exports.syncOddUpdateStrategyGamblerSettings = exports.refetchStake = exports.selectBetslipBetId = exports.changeMode = exports.removePlacedBetslipOdds = exports.setEditingStatus = void 0;
var Observable_1 = require("rxjs/Observable");
var lodash_1 = require("lodash");
var reselect_1 = require("reselect");
require("rxjs/add/observable/of");
require("rxjs/add/observable/empty");
require("rxjs/add/operator/map");
require("rxjs/add/operator/filter");
require("rxjs/add/observable/timer");
require("rxjs/add/observable/race");
require("rxjs/add/operator/take");
require("rxjs/add/observable/fromPromise");
var core_1 = __importStar(require("@gin-betting/core"));
var gambler_settings_1 = __importDefault(require("@gin-betting/gambler-settings"));
var constants_1 = require("./constants");
var actions_1 = require("./actions");
var selectors_1 = require("./selectors");
var utils_1 = require("./utils");
var normalizeEntity = core_1.default.entities.normalizeEntity, _a = core_1.default.async, UPDATE_BET = _a.constants.UPDATE_BET, updateBet = _a.actions.updateBet, sentryHub = core_1.default.services.sentryHub, getIdsFromBetslipOddId = core_1.default.utils.getIdsFromBetslipOddId;
var makeSyncGamblerSettings = gambler_settings_1.default.epics.makeSyncGamblerSettings, unknownChangeGamblerSetting = gambler_settings_1.default.actions.changeGamblerSetting;
var changeGamblerSetting = unknownChangeGamblerSetting;
var REFETCH_STAKE_TIMEOUT = 32 * 1000;
var setEditingStatus = function (action$, state$) {
    return action$
        .ofType(constants_1.DELETE_BETSLIP_ODD, constants_1.CHANGE_BET_MODE, constants_1.CHANGE_BETSLIP_BET_STAKE, constants_1.TOGGLE_SYSTEM_COMBINATION, constants_1.CHANGE_BETSLIP_ODD_STAKE)
        .mergeMap(function (action) {
        var betslipBetId;
        switch (action.type) {
            case constants_1.DELETE_BETSLIP_ODD:
            case constants_1.CHANGE_BET_MODE:
            case constants_1.TOGGLE_SYSTEM_COMBINATION:
            case constants_1.CHANGE_BETSLIP_BET_STAKE: {
                betslipBetId = action.payload.betslipBetId;
                break;
            }
            case constants_1.CHANGE_BETSLIP_ODD_STAKE: {
                betslipBetId = getIdsFromBetslipOddId(action.payload.betslipOddId).betslipBetId;
                break;
            }
            default: {
                break;
            }
        }
        if (!betslipBetId)
            return Observable_1.Observable.empty();
        var state = state$.getState();
        var betslipBet = selectors_1.selectBetslipBetWithStatus(state, {
            betslipBetId: betslipBetId,
        });
        if (!betslipBet ||
            betslipBet.status === core_1.App.BetslipStatus.INITIAL ||
            !lodash_1.includes(constants_1.BETSLIP_ODD_STATUSES_TO_PLACE_BET, betslipBet.status)) {
            return Observable_1.Observable.empty();
        }
        return Observable_1.Observable.of(actions_1.setInitialBetslip({ betslipBetId: betslipBetId }));
    });
};
exports.setEditingStatus = setEditingStatus;
var removePlacedBetslipOdds = function (action$, state$) {
    var selectProps = reselect_1.createStructuredSelector({
        betslipBet: selectors_1.selectBetslipBetWithStatus,
        betslipOdds: selectors_1.selectBetslipOddsByBetslipBetId,
    });
    return action$
        .ofType(constants_1.CHANGE_BET_MODE)
        .mergeMap(function (_a) {
        var betslipBetId = _a.payload.betslipBetId;
        var state = state$.getState();
        var _b = selectProps(state, {
            betslipBetId: betslipBetId,
        }), betslipBet = _b.betslipBet, betslipOdds = _b.betslipOdds;
        if (!betslipBet)
            return Observable_1.Observable.empty();
        var betslipOddIds = betslipBet.betslipOddIds;
        var outdatedBetslipOddIds = betslipOddIds.filter(function (betslipOddId) {
            var betslipOdd = betslipOdds.get(betslipOddId);
            return (!betslipOdd ||
                !lodash_1.includes(constants_1.BETSLIP_ODD_STATUSES_TO_PLACE_BET, betslipOdd.singleStatus));
        });
        return outdatedBetslipOddIds
            .map(function (betslipOddId) {
            return Observable_1.Observable.of(actions_1.deleteBetslipOdd({
                betslipBetId: betslipBetId,
                oddId: getIdsFromBetslipOddId(betslipOddId).oddId,
            }));
        })
            .toArray();
    });
};
exports.removePlacedBetslipOdds = removePlacedBetslipOdds;
var changeMode = function (action$, state$) {
    return action$
        .ofType(constants_1.ADD_BETSLIP_ODD, constants_1.DELETE_BETSLIP_ODD, constants_1.DELETE_BETSLIP_ODDS)
        .mergeMap(function (_a) {
        var type = _a.type, betslipBetId = _a.payload.betslipBetId;
        var state = state$.getState();
        var betslipBet = selectors_1.selectBetslipBetWithStatus(state, {
            betslipBetId: betslipBetId,
        });
        if (!betslipBet)
            return Observable_1.Observable.empty();
        var betslipOddIds = betslipBet.betslipOddIds, mode = betslipBet.mode, status = betslipBet.status;
        // NOTE: Don't change betType on add odd in processing betslip.
        if (!lodash_1.includes(constants_1.BETSLIP_ODD_STATUSES_TO_PLACE_BET, status)) {
            return Observable_1.Observable.empty();
        }
        var nextMode = utils_1.getNextModeBySize({
            mode: mode,
            nextBetslipOddIds: betslipOddIds,
            isIncreasing: type === constants_1.ADD_BETSLIP_ODD,
        });
        if (mode === nextMode)
            return Observable_1.Observable.empty();
        return Observable_1.Observable.of(actions_1.changeBetslipMode({ betslipBetId: betslipBetId, mode: nextMode }));
    });
};
exports.changeMode = changeMode;
var selectBetslipBetId = function (action$, state$) {
    return action$
        .ofType(constants_1.ADD_BETSLIP_ODD)
        .mergeMap(function (_a) {
        var betslipBetId = _a.payload.betslipBetId;
        var state = state$.getState();
        var chosenBetslipBetId = selectors_1.selectChosenBetslipBetId(state);
        if (chosenBetslipBetId === betslipBetId)
            return Observable_1.Observable.empty();
        return Observable_1.Observable.of(actions_1.choseBetslipBetId({ betslipBetId: betslipBetId }));
    });
};
exports.selectBetslipBetId = selectBetslipBetId;
var refetchStake = function (action$) {
    return action$
        .ofType(constants_1.CREATE_BETS_SUCCESS)
        .mergeMap(function (action) {
        var betId = action.payload.result;
        var res = lodash_1.get(action, ['payload', 'entities', 'bets', betId]);
        if (!res) {
            return Observable_1.Observable.empty();
        }
        var bet = res;
        return Observable_1.Observable.race(Observable_1.Observable.timer(REFETCH_STAKE_TIMEOUT), action$
            .ofType(UPDATE_BET)
            .filter(function (item) {
            return lodash_1.get(item, ['payload', 'entities', 'bets', betId]);
        })
            .take(1)).mergeMap(function (val) {
            if (typeof val === 'number') {
                sentryHub.withScope(function (scope) {
                    scope.setTag('origin', 'betslipEpic');
                    sentryHub.captureMessage("Didnt get update of bet for " + REFETCH_STAKE_TIMEOUT);
                });
                return Observable_1.Observable.of(bet.id);
            }
            // we have got an update
            return Observable_1.Observable.empty();
        });
    })
        .mergeMap(function (betId) {
        var promise = core_1.default.appServiceLocator
            .get('apiClient')
            .makeRequest({
            method: 'getBets',
            variables: { input: { ids: [betId] } },
        });
        return Observable_1.Observable.fromPromise(promise);
    })
        .mergeMap(function (res) {
        // TODO: refetch bet if status is any except ACCEPTED or DECLINED
        if (!res.data) {
            return Observable_1.Observable.empty();
        }
        var bets = res.data.bets;
        var entities = normalizeEntity({
            bets: bets,
        }).entities;
        if (lodash_1.isEmpty(entities)) {
            return Observable_1.Observable.empty();
        }
        return Observable_1.Observable.of(updateBet(entities));
    });
};
exports.refetchStake = refetchStake;
var syncOddUpdateStrategyGamblerSettings = function (actions$) {
    return actions$.ofType(constants_1.CHANGE_COEF_UPDATES).map(function (action) {
        var oddStatus = action.payload.oddUpdateStatus;
        return changeGamblerSetting(constants_1.BetslipSettingKey.BETSLIP_ODD_UPDATE_STRATEGY, oddStatus);
    });
};
exports.syncOddUpdateStrategyGamblerSettings = syncOddUpdateStrategyGamblerSettings;
exports.syncSyncGamblerSettings = makeSyncGamblerSettings(constants_1.BETSLIP_GAMBLER_SETTINGS);
//# sourceMappingURL=epics.js.map